import axios from '@/lib/axios';
import { FixedAsset, Product, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0600. 発注案件メンバー登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_members
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  user_id: number;
};
const createPurchaseOrderMember = (props: Props): Promise<PurchaseOrderMember> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_members`, props);
};

export const useCreatePurchaseOrderMember = () => {
  return useMutation({
    mutationFn: createPurchaseOrderMember,
  });
};
